module.exports = __webpack_public_path__ + "images/directlease_small3e1d427831c90e53eebc849ae7bb7070.png";